import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import React,{Component} from 'react';
import Modal from 'react-modal';
import firebase from 'firebase';
import secondaryApp from '../BD/secondaryApp';
import Alert from 'react-s-alert';
import axios from 'axios';

const qrCode = require('qrcode-npm')

const text="-L6TFyzo5H6lBpdIisHA";
const qr = qrCode.qrcode(4, 'M');




const customStyles = {
  content : {
    top                   : '65%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    transform             : 'translate(-50%, -50%)',
	width                 : '450px'
	
  }
};
const customStyles2 = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    transform             : 'translate(-50%, -50%)',
	width                 : '450px'
	
  }
};

const database=firebase.database();


class ModalInvitados extends Component{
	
	constructor(props){
		
		super(props);
		this.state={
			
			isActive:false,
			isActiveEmpresas:false,
			isActiveInformacion:false,
			empresas:[],
			nombre:'',
			apellido:'',
			dui:'',
			pasaporte:'',
			correo:'',
			contrasena:'',
			nombre_empresa:'',			
			fecha_inicio:'',
			fecha_final:'',
			hora_inicio:'',
			hora_final:'',
			objEmpresa:null
			
		}
			
		this.toggleModal=this.toggleModal.bind(this);
		this.toggleModalInformacion=this.toggleModalInformacion.bind(this);
		this.toggleModalEmpresas=this.toggleModalEmpresas.bind(this);
		this.btnEmpresasFormatter=this.btnEmpresasFormatter.bind(this);
		this.handleSubmit=this.handleSubmit.bind(this);
		this.handleClickEmpresas=this.handleClickEmpresas.bind(this);
		this.handleKeyPressDui=this.handleKeyPressDui.bind(this);
		this.empresasRef=database.ref().child('Empresa');
		this.invitadosRef=database.ref().child('Invitados');
		
		
		
	}
	
	
	toggleModal(){		
		this.setState({	
			isActive:!this.state.isActive
		});		
	}
	
	toggleModalEmpresas(){
		this.setState({
			isActiveEmpresas:!this.state.isActiveEmpresas			
		});		
	}
	toggleModalInformacion(){
		
		this.setState({
			
			isActiveInformacion:!this.state.isActiveInformacion
			
		})
		
	}
	
	componentDidMount(){
		
		this.empresasRef.on('value',this.gotData,this.errData);
		
	}
	
	gotData=(data)=>{
		
		
		let newEmpresas=[];
		
		let dataempresas=data.val();
		
		if(dataempresas!==null){
			
			
			let keys=Object.keys(dataempresas);
			
			for(let i=0;i<keys.length;i++){
				
				let k=keys[i];
				
				if(dataempresas[k].estado==='Activo'){
					
					newEmpresas.push({
					
						key:k,
						codigo_activacion:dataempresas[k].codigo_activacion,
						codigo_empresa:dataempresas[k].codigo_empresa,
						correo:dataempresas[k].correo,
						estado:dataempresas[k].estado,
						razon_social:dataempresas[k].razon_social,
						representante:dataempresas[k].representante,
						telefono_empresa:dataempresas[k].telefono_empresa
										
					});
									
				}
			}
			this.setState({empresas:newEmpresas});
		}
	}
	errData=(err)=>{
		
		
	}
	
	
	handleClickEmpresas(row){
		
		this.empresa.value=row.codigo_empresa;
		this.setState({
			objEmpresa:row
		});
		this.toggleModalEmpresas();
	
	}
	
	
	
	 handleSubmit(event){
			
		
		
		event.preventDefault();		
		
		
		
		
		const correo_contacto=this.contacto.value;
		const usuario='usuario_creado@mail.com';
		const clave='clave_generada';
		
		
		//Datos del la persona
		let nombre=this.nombre.value;
		let apellido=this.apellido.value;
		let dui=this.dui.value;
		let pasaporte=this.pasaporte.value;
		let empresa=this.empresa.value;
		
		//Datos del periodo de vijencia 
		let fecha_inicio=this.fecha_inicio.value;
		let fecha_final=this.fecha_final.value;
		let hora_inicio=this.hora_inicio.value;
		let hora_final=this.hora_final.value;
		
		
		
		let key=this.invitadosRef.push({
			
			nombre:nombre,
			apellido:apellido,
			pasaporte:pasaporte,
			dui:dui,
			nombre_empresa:this.empresa.value,
			fecha_inicio:this.fecha_inicio.value,
			fecha_final:this.fecha_final.value,
			hora_inicio:this.hora_inicio.value,
			hora_final:this.hora_final.value,
			codigo_empresa:this.state.objEmpresa.key,
			estado:'subir'
			
		})
		
		
		//Generacion de la key la contrasena
		
		let subkey=key.getKey().substring(1,7);
		
		let nombre_split=nombre.split(' ');
		let mail=(subkey+'.'+nombre_split[0].toLowerCase()+'@mail.com').toLowerCase();
		let password=nombre.substring(0,1).toLowerCase()+apellido.substring(0,1).toLowerCase()+parseInt(Math.random()*(9999,1000)+1000);
		

		
		secondaryApp.auth().createUserWithEmailAndPassword(mail,password)
		.then(user => {
			
			
				
				this.invitadosRef.child(key.getKey()).update({
					
					correo:mail,
					contrasena:password
			
				});
		
				
		
				qr.addData(key.getKey());
				qr.make();
				
				
				let escapedStr=qr.createImgTag(4);
		
				let arreglo=escapedStr.split('"');

		
				const form=  axios.post('/contact',{
					mail:correo_contacto,
					imagen:arreglo[1],
					usuario:mail,
					clave:password,
					nombre:nombre+' '+apellido,
					empresa:empresa,
					fecha_inicio:fecha_inicio,
					fecha_fin:fecha_final,
					hora_inicio:hora_inicio,
					hora_fin:hora_final					
				});
				
			
		
				this.setState({			
					nombre:nombre,
					apellido:apellido,
					nombre_empresa:empresa,
					correo:mail,
					contrasena:password,
					fecha_inicio:fecha_inicio,
					fecha_final:fecha_final,
					hora_inicio:hora_inicio,
					hora_final:hora_final
				})
				
			
				Alert.success('Datos guardados correctamente', {
					effect: 'genie',
					position: 'bottom-right',
					timeout:2000			
				});
				
				this.toggleModalInformacion();
				
		
		})
		.catch(error =>{
			
				this.invitadosRef.child(key.getKey()).remove();
			
				let msj='Error al ingresar usuario';
				
			
				if(error.code==='auth/email-already-in-use'){	
					msj='Ya existe una cuenta con la dirección de correo electrónico especificada.';
				}
				else if(error.code==='auth/invalid-email'){					
					msj='Dirección de correo electronico no valida.';					
				}
				
				else if(error.code==='auth/weak-password'){
					
					msj='La contraseña ingresada no es demasiado fuerte.';
						
				}

				Alert.error(msj, {
						effect: 'genie',
						position: 'bottom-right',
						timeout:2000			
				});
			
				
		});
	
		this.toggleModal();
		
		
	}
	
	btnEmpresasFormatter(cell,row){
				
		return <button className="btn btn-success btn-sm" onClick={() => {this.handleClickEmpresas(row)}} >Seleccionar</button>;
	}
	
	
	handleKeyPressDui(e){
		
		let dui=this.dui.value;
		let tecla=e.which;
		
		if(dui.length===8)
		{
			if(!(tecla===45)){
				
				e.preventDefault();
			}
			
		}else{
			
			
			let patron =/^[0-9]+$/;
			
			let tecla_final = String.fromCharCode(tecla);
			
			let rs=patron.test(tecla_final);
		
			if(!rs){
				
				e.preventDefault();
			}
		}
			
	}
	
 
	
	render(){
			
		return(
				<div className="modal_invitados">
					<button className="btn btn-primary" onClick={this.toggleModal}><span className="glyphicon glyphicon-plus"> </span> Nuevo</button>
					
					<Modal isOpen={this.state.isActive} onRequestClose={this.toggleModal}  style={customStyles} >				
					
							<h3>Agregar invitado</h3>
							
							<hr/>
					
							<form method="POST" action="" onSubmit={this.handleSubmit}>
								<div className="form-group">
									<label htmlFor="nombre" >Nombre</label>
									<input type="text" name="nombre"  placeholder="Nombre" className="form-control"
									required autoComplete="off" 
									ref={input=>{this.nombre=input}}
									
									/>
								</div>
								<div className="form-group">
									<label htmlFor="apellido">Apellido</label>
									<input type="text" name="apellido" className="form-control" placeholder="Apellido"
									required autoComplete="off" 
									ref={input=>{this.apellido=input}}
									/>
								</div>
								<div className="form-group">
								    <label htmlFor="dui">Dui</label>
									<input type="text" name="dui" className="form-control" placeholder="Dui"
									required autoComplete="off" 
									ref={input=>{this.dui=input}} onKeyPress={this.handleKeyPressDui} maxLength="10" minLength="10"
									/>								
								</div>
								<div className="form-group">
									<label htmlFor="email">Correo de contacto</label>
									<input type="email" name="mail" className="form-control" placeholder="Correo de contacto"
									required autoComplete="off"
									ref={input=>{this.contacto=input}}
									
									/>
								</div>
		
								<div className="form-group">
									<label htmlFor="fecha_inicio">Fecha Inicio</label>
									<input type="date" name="fecha_inicio" className="form-control" placeholder="Fecha inicio"
									required
									ref={input=>{this.fecha_inicio=input}}
									/>
								</div>
								<div className="form-group">
									<label htmlFor="fecha_final">Fecha Final</label>
									<input type="date" name="fecha_final" className="form-control" placeholder="Fecha final"
									required
									ref={input=>{this.fecha_final=input}}
									/>
								</div>
								<div className="form-group">
									<label htmlFor="fecha_inicio">Hora Inicio</label>
									<input type="time" name="fecha_inicio" className="form-control" placeholder="Fecha inicio"
									required
									ref={input=>{this.hora_inicio=input}}
									/>
								</div>
								<div className="form-group">
									<label htmlFor="fecha_final">Hora Final</label>
									<input type="time" name="fecha_final" className="form-control" placeholder="Fecha final"
									required
									ref={input=>{this.hora_final=input}}
									/>
								</div>
								
								<div className="form-group">
									<label htmlFor="pasaporte">Pasaporte</label>
									<input type="text"  name="pasaporte" className="form-control" placeholder="Pasaporte"
									required autoComplete="off" 
										ref={input=>{this.pasaporte=input}}
									/>
								</div>
								<div className="form-group">
									<label htmlFor="empresa">Empresa</label>
									<input type="text" placeholder="Seleccionar empresa" name="empresa" className="form-control" required maxLength="0" onClick={this.toggleModalEmpresas}
									ref={input=>{this.empresa=input}}
									/>
									
								
								</div>
								
							<button type="submit" className="btn btn-primary buttons" >Guardar</button>
						</form>
							<button type="button" className="btn btn-default buttons  btnmargin" onClick={this.toggleModal}>Cerrar</button>
					
					</Modal>
					
					<Modal isOpen={this.state.isActiveEmpresas} onRequestClose={this.toggleModalEmpresas} style={customStyles}>
						<h4>Selecciona una base</h4>
						<hr/>
						<BootstrapTable data={ this.state.empresas}
							 ref='table'
							 pagination={ true }
							 search={ true }
							 hover
							 >
							 <TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
							 <TableHeaderColumn dataField='codigo_empresa' dataSort={true}  >Nombre</TableHeaderColumn>	
							 <TableHeaderColumn dataField='edit' dataAlign='center' dataFormat={ this.btnEmpresasFormatter.bind(this) }>Seleccionar</TableHeaderColumn>							 
						</BootstrapTable>
												
					</Modal>
					
					<Modal isOpen={this.state.isActiveInformacion} onRequestClose={this.toggleModalInformacion} style={customStyles2}>
						<fieldset>
						<legend>Información del invitado</legend>						
						<hr/>
						<label>Nombre del invitado</label>
						<p>{this.state.nombre+' '+this.state.apellido}</p>
						<label>Invitado de la empresa</label>
						<p>{this.state.nombre_empresa}</p>
						<label>Fecha de inicio</label>
						<p>{this.state.fecha_inicio}</p>
						<label>Fecha fin</label>
						<p>{this.state.fecha_final}</p>
						<label>Hora inicio</label>
						<p>{this.state.hora_inicio}</p>
						<label>Hora fin</label>
						<p>{this.state.hora_final}</p>
						<label>Correo</label>
						<p>{this.state.correo}</p>
						<label>Contraseña</label>
						<p>{this.state.contrasena}</p>
						
						<hr/>
						<button type="button" className="btn btn-danger buttons" onClick={this.toggleModalInformacion} > Cerrar</button>
						</fieldset>
					</Modal>
					
					
				</div>
		);	
	}
}

export default ModalInvitados;


// WEBPACK FOOTER //
// ./src/Components/Invitados/ModalInvitados.js